export default __webpack_public_path__ + "images/7c727d9dd0070a324ad39edaef16dfe1-check-circle.svg";